import { LocalStorageItem } from './localStorageItem';

const authToken = new LocalStorageItem<string>('authToken');
const currentUserId = new LocalStorageItem<string>('currentUserId');
const currentUserVariant = new LocalStorageItem<string>('currentUserVariant');
const currentAccountId = new LocalStorageItem<string>('currentAccountId');
const currentCallCenterId = new LocalStorageItem<string>('currentCallCenterId');
const currentCompanyId = new LocalStorageItem<string>('currentCompanyId');

/**
 * TODO: make this private to the authContext
 */
export const AuthStorage = {
  authToken,
  currentUserId,
  currentUserVariant,
  currentAccountId,
  currentCallCenterId,
  currentCompanyId
};
